import moment from "moment";

const initialCollaboratorState = {
  fetching: false,
  fetched: false,
  collaborator: null,
  data: {
    kpi: null,
    annual: null,
    current: null,
    dynamic: null
  },
  filter: {
    role: null,
    qp: null,
    analysisPlan: "",
    isAnnual: false,
    analyseDate: null,
    arrivalDate: null,
    departureDate: null,
    lastDate: null,
    clientName: ""
  },
  tab: null,
  error: null,
  organization: null
};

export const capacityPlaningCollaboratorReducer = (
  state = initialCollaboratorState,
  action
) => {
  switch (action.type) {
    case "SET_CAPACITY_PLANING_COLLABORATOR_TAB": {
      return {
        ...state,
        tab: action.item
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR_DATE": {
      return {
        ...state,
        filter: { ...state.filter, analyseDate: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR_ROLE": {
      return {
        ...state,
        filter: { ...state.filter, role: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR_STATE": {
      return {
        ...state,
        filter: { ...state.filter, qp: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR_ANALYSIS_PLAN": {
      return {
        ...state,
        filter: { ...state.filter, analysisPlan: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR_ANNUAL": {
      return {
        ...state,
        filter: { ...state.filter, isAnnual: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR": {
      return {
        ...state,
        collaborator: action.item
      };
    }
    case "SET_CAPACITY_PLANING_COLLABORATOR_FILTER_NAME": {
      return {
        ...state,
        filter: { ...state.filter, clientName: action.searchWord }
      };
    }
    case "FETCH_CAPACITY_PLANING_COLLABORATOR_KPI_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CAPACITY_PLANING_COLLABORATOR_KPI_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        collaborator:
          state.collaborator == null
            ? action.payload.data.data.collaborator
            : state.collaborator,
        data: { ...state.data, kpi: action.payload.data.data },
        filter: {
          ...state.filter,
          lastDate: moment(
            action.payload.data.data.lastImport,
            "YYYY-MM-DD hh:mm:ss"
          ),
          analyseDate: state.filter.analyseDate
            ? state.filter.analyseDate
            : moment(
                action.payload.data.data.lastImport,
                "YYYY-MM-DD hh:mm:ss"
              ),
          departureDate: action.payload.data.data.departureDate
            ? moment(
                action.payload.data.data.departureDate,
                "YYYY-MM-DD hh:mm:ss"
              )
            : null,
          arrivalDate: action.payload.data.data.arrivalDate
            ? moment(
                action.payload.data.data.arrivalDate,
                "YYYY-MM-DD hh:mm:ss"
              )
            : null
        },
        organization: action.payload.organization
      };
    }
    case "FETCH_CAPACITY_PLANING_COLLABORATOR_KPI_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }
    case "INIT_CLIENTS_CAPACITY_PLANING_COLLABORATOR": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        data: {
          kpi: null,
          annual: null,
          current: null,
          dynamic: null
        },
        filter: {
          role: null,
          superCategory: ""
        },
        error: null
      };
    }
    case "FETCH_CAPACITY_PLANING_COLLABORATOR_CLIENTS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CAPACITY_PLANING_COLLABORATOR_CLIENTS_FULFILLED": {
      let data =
        state.tab === "MODEL_ANNUAL_CLIENTS"
          ? { ...state.data, annual: action.payload.data.data }
          : state.tab === "MODEL_CURRENT_CLIENTS"
            ? { ...state.data, current: action.payload.data.data }
            : { ...state.data, dynamic: action.payload.data.data };
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data,
        filter: {
          ...state.filter,
          lastDate: moment(
            action.payload.data.data && action.payload.data.data.lastImport,
            "YYYY-MM-DD hh:mm:ss"
          ),
          analyseDate: state.filter.analyseDate
            ? state.filter.analyseDate
            : moment(
                action.payload.data.data && action.payload.data.data.lastImport,
                "YYYY-MM-DD hh:mm:ss"
              ),
          arrivalDate:
            action.payload.data.data && action.payload.data.data.arrivalDate
              ? moment(
                  action.payload.data.data.arrivalDate,
                  "YYYY-MM-DD hh:mm:ss"
                )
              : null,
          departureDate:
            action.payload.data.data && action.payload.data.data.departureDate
              ? moment(
                  action.payload.data.data.departureDate,
                  "YYYY-MM-DD hh:mm:ss"
                )
              : null
        },
        organization: action.payload.organization
      };
    }
    case "FETCH_CAPACITY_PLANING_COLLABORATOR_CLIENTS_REJECTED": {
      let error = action.payload;
      let data =
        state.tab === "MODEL_ANNUAL_CLIENTS"
          ? { ...state.data, annual: [] }
          : state.tab === "MODEL_CURRENT_CLIENTS"
            ? { ...state.data, current: [] }
            : { ...state.data, dynamic: [] };
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        data,
        error
      };
    }
    default:
      return state;
  }
};

const initialProductionState = {
  fetching: false,
  fetched: false,
  data: [],
  filter: {
    analyseDate: null,
    lastDate: null,
    searchWord: "",
    collaboratorState: []
  },
  year: moment().year(),
  error: null,
  grouped: {
    fetching: false,
    fetched: false,
    data: [],
    filter: {
      collaboratorBudgetSortBy: { selected: "" },
      collaboratorRole: { selected: "" },
      VATPeriodicity: [],
      closingDate: { selected: "" }
    },
    error: null
  }
};

export const capacityPlaningProductionReducer = (
  state = initialProductionState,
  action
) => {
  switch (action.type) {
    case "INIT_CAPACITY_PLANING_PRODUCTION": {
      return initialProductionState;
    }
    case "SET_CAPACITY_PLANING_PRODUCTION_DATE": {
      return {
        ...state,
        filter: { ...state.filter, analyseDate: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_PRODUCTION_YEAR": {
      return {
        ...state,
        year: action.year
      };
    }
    case "SET_CAPACITY_PLANING_PRODUCTION_ROLE": {
      return {
        ...state,
        filter: { ...state.filter, role: action.item }
      };
    }
    case "SET_CAPACITY_PLANING_PRODUCTION_FILTER_SEARCH_WORD": {
      return {
        ...state,
        filter: { ...state.filter, searchWord: action.searchWord }
      };
    }
    case "SET_CAPACITY_PLANING_PRODUCTION_FILTER_STATE": {
      return {
        ...state,
        filter: {
          ...state.filter,
          collaboratorState: action.collaboratorState
        }
      };
    }
    case "FETCH_CAPACITY_PLANING_PRODUCTION_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_CAPACITY_PLANING_PRODUCTION_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: action.payload.data.data.data,
        filter: {
          ...state.filter,
          lastDate: moment(
            action.payload.data.data.lastImport,
            "YYYY-MM-DD hh:mm:ss"
          ),
          analyseDate: state.filter.analyseDate
            ? state.filter.analyseDate
            : moment().format("YYYY-MM-DD hh:mm:ss")
        }
      };
    }
    case "FETCH_CAPACITY_PLANING_PRODUCTION_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }
    case "SET_COLLABORATOR_ROLE_GROUPED": {
      const { grouped } = state;
      const { selected } = action;
      return {
        ...state,
        grouped: {
          ...grouped,
          filter: {
            ...grouped.filter,
            collaboratorRole: {
              selected
            }
          }
        }
      };
    }
    case "SET_COLLABORATOR_BUDGET_SORT_BY_GROUPED": {
      const { grouped } = state;
      const { selected } = action;
      return {
        ...state,
        grouped: {
          ...grouped,
          filter: {
            ...grouped.filter,
            collaboratorBudgetSortBy: {
              selected
            }
          }
        }
      };
    }
    case "SET_CLOSING_DATE_CLIENTS": {
      const { grouped } = state;
      const { selected } = action;
      return {
        ...state,
        grouped: {
          ...grouped,
          filter: {
            ...grouped.filter,
            closingDate: {
              selected
            }
          }
        }
      };
    }

    case "SET_VAT_PERIODICITY": {
      const { grouped } = state;
      const { selected } = action;
      return {
        ...state,
        grouped: {
          ...grouped,
          filter: {
            ...grouped.filter,
            VATPeriodicity: selected
          }
        }
      };
    }

    case "FETCH_GROUPED_CAPACITY_PLANING_CLIENTS_PENDING": {
      return {
        ...state,
        grouped: {
          ...state.grouped,
          fetching: true,
          fetched: false,
          error: null
        }
      };
    }
    case "FETCH_GROUPED_CAPACITY_PLANING_CLIENTS_FULFILLED": {
      return {
        ...state,
        grouped: {
          ...state.grouped,
          fetching: false,
          fetched: true,
          error: null,
          data: action.payload.data.data
        }
      };
    }
    case "FETCH_GROUPED_CAPACITY_PLANING_CLIENTS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        grouped: {
          ...state.grouped,
          fetching: false,
          fetched: false,
          data: [],
          error
        }
      };
    }
    default:
      return state;
  }
};

const initialCollaboratorFinancialState = {
  fetching: false,
  fetched: false,
  data: [],
  error: null,
  columns: [
    "budget",
    "collabReal",
    "caAdjusted",
    "benchmarkEffectif",
    "benchmarkBudgetaire"
  ],
  filter: {
    searchWord: ""
  }
};
export const collaboratorFinancialReducer = (
  state = initialCollaboratorFinancialState,
  action
) => {
  switch (action.type) {
    case "INIT_COLLABORATOR_FINANCIAL": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        data: [],
        error: null
      };
    }
    case "SET_COLLABORATOR_FINANCIAL_FILTER_SEARCH_WORD": {
      return {
        ...state,
        filter: { ...state.filter, searchWord: action.searchWord }
      };
    }
    case "FETCH_COLLABORATOR_FINANCIAL_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_COLLABORATOR_FINANCIAL_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: data.data
      };
    }
    case "FETCH_COLLABORATOR_FINANCIAL_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        data: [],
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};

const initialExportCapacityDossierState = {
  fetching: false,
  fetched: false,
  error: null
};

export const exportCapacityDossierReducer = (
  state = initialExportCapacityDossierState,
  action
) => {
  switch (action.type) {
    case "INIT_EXPORT_CAPACITY_DOSSIER": {
      return initialExportCapacityDossierState;
    }
    case "EXPORT_CAPACITY_DOSSIER_PENDING": {
      return { ...state, fetching: true };
    }
    case "EXPORT_CAPACITY_DOSSIER_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null
      };
    }
    case "EXPORT_CAPACITY_DOSSIER_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/capacity.js